import React, { useContext, useEffect, useState } from 'react'
import { sidebarContext } from '../../App'
import TelecallerHeader from './TelecallerHeader'

export default function TelecallerDashboard() {
  const token = localStorage.getItem('token')
  const {setHS} = useContext(sidebarContext)
  const [data, setData] = useState({})

  useEffect(() => {
    setHS(0)
  },[setHS])

  return (
    <div className='min-h-screen bg-gradient-to-tr from-blue-100 via-white to-blue-100 ml-64 5xl:ml-0 justify-between items-center'>
      <TelecallerHeader/>

      <div className='pt-24 px-6 max-w-7xl mx-auto'>
        <div className='mb-10 text-center'>
          <h1 className='text-3xl font-bold mb-2 uppercase'>Telecaller Dashboard</h1>
        </div>
      </div>
    </div>  )
}
